import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import InputField from '../../FormComponents/InputField/InputField'
import CheckboxesList from '../../FormComponents/CheckboxesList/CheckboxesList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { emailAlertsConstants } from '../constants'
import { page as pageIndex } from '../../../globals'

class BasicSettings extends PureComponent {
  render () {
    const { trackData, updateData } = this.props
    return <Fragment>
      <div className="form-element">
        <div className="flex-container space-between alerts-title">
          <span className="form-text-subtitle">E-Mail Address</span>
        </div>
        <div className="flex-container col-md-4 p-0">
          <div className="icon-with-bg">
            <FontAwesomeIcon icon={faEnvelope} alt="report title icon" />
          </div>
          <div className="p-0 col">
            <InputField
              type="text"
              location={{ page: pageIndex.dashboard, field: 'emailCategory' }}
              id="emailAddress"
              placeholder="E-Mail Address"
              value={trackData.emailCategory.textValues.emailAddress}
              updateData={updateData}
            />
          </div>
        </div>
      </div>
      <div className="form-element">
        <div className="flex-container space-between alerts-title">
          <div className="flex-column text-left col-md-4 checkboxes-container">
            <span className="form-text-subtitle">Alerts Options</span>
          </div>
          <div className="flex-column text-left col-md-4 checkboxes-container">
            <span className="form-text-subtitle">Title for options here</span>
          </div>
        </div>
        <div className="flex-container space-between">
          <div className="flex-column col-md-4 checkboxes-container">
            <CheckboxesList
              location={{ page: pageIndex.dashboard, field: 'alertsOptions' }}
              fieldData={emailAlertsConstants.alertsOptionsValues}
              values={trackData.alertsOptions}
              updateData={updateData}
            />
          </div>
          <div className="flex-column col-md-4 checkboxes-container">
            <CheckboxesList
              location={{ page: pageIndex.dashboard, field: 'alertSwitchers' }}
              fieldData={emailAlertsConstants.basicSettings}
              values={trackData.alertSwitchers}
              updateData={updateData}
            />
          </div>
        </div>
      </div>
    </Fragment>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func
  }
}

export default BasicSettings



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/components/BasicSettings.js